import $ from 'jquery';
import Swiper from 'swiper/bundle';

// eslint-disable-next-line no-undef
const object = gralObject;

const initializeBlock = ($block) => {
    const slider = $block.find('.catalogs-block__slider');
    const count = slider.attr('data-count') * 1;
    new Swiper(slider[0], {
        slidesPerView: count,
        spaceBetween: 30,
        watchOverflow: true,
    });
};

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=gral-catalogs',
        initializeBlock
    );
} else {
    const swiperBreakpointCheck = () => {
        $('.catalogs-block').each(function () {
            const current = $(this);
            const slider = current.find('.swiper');
            const count = slider.attr('data-count') * 1;

            const enableSwiper = () => {
                new Swiper(current.find('.catalogs-block__slider')[0], {
                    slidesPerView: count,
                    spaceBetween: 30,
                    watchOverflow: true,
                });
            };

            if (window.matchMedia('(min-width: 992px)').matches) {
                enableSwiper();
            } else {
                if (slider[0].swiper && slider[0].swiper !== null) {
                    slider[0].swiper.destroy(true, true);
                }
            }
        });
    };

    $(window).on('resize', swiperBreakpointCheck).trigger('resize');
}


$('.catalogs-block').each(function () {
    const el = $(this).find('.catalogs-block__slider-smile')

    new Swiper(el[0], {
        slidesPerView: 1,
        watchOverflow: false,
        effect: 'fade',
        autoplay: {
            delay: 5000,
        },
    })
});

